export class ClientMembership {
  timeStarted: Date = null;
  timeExpiring: Date = null;
  productTypeId: number = null;
}
